import React from 'react'
import bg from '../../Assets/Background.jpg'
import book from '../../Assets/book.png'



function Booking() {
  return (
    <div  style={{
           
        height: '550px',
        // boxShadow:' 0px 0px 30px -15px rgba(30,70,246,1)',
    }}  className="border w-full sm:w-[90%] lg:w-[85%] 2xl:w-[78%] sm:rounded-[40px] overflow-clip flex flex-col lg:flex-row bg-[#1d2b33]">
    <div className="w-full py-10 lg:py-0 lg:w-[52%] flex flex-col justify-center items-center">
        <div className='w-[80%] flex flex-col justify-center gap-4 text-white'>
       
    <span className='semibold text-left text-[15px] lg:text-[17px] '>Explore Elyzian in Action</span>  
        <span className='bold text-[20px] sm:text-[24px] lg:text-[30px] '>Connect with us for a Personalized Discussions</span>    
       
        <span className='regular text-sm lg:text-[15px] leading-[36px] '>Enhance Your Awareness with Multiple Listening Platforms
        </span>
        <div className='flex items-center gap-2'>
        <button  className="flex items-center gap-2 text-sm  sm:text-[14px]  tracking-wide rounded-lg hover:shadow  hover:ring-[2px] bold px-3 py-2 sm:px-5  sm:p-[12px] bg-[#f3f5ff] text-gray-700 text-semibold border  border-opacity-25 hover:transition hover:delay-200">
<span className="button-content medium">Get Started Free </span>
</button>
<button  className="flex items-center gap-2 text-sm  sm:text-[14px]  tracking-wide rounded-lg hover:shadow  hover:ring-[2px] bold px-3 py-2 sm:px-5  sm:p-[12px] bg-transparent text-white border borderborder-opacity-25 hover:transition hover:delay-200">
<span className="button-content medium">Book a time</span>
</button>
        </div>
        </div>
    </div>
  <div style={{
        backgroundImage: `url(${book})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
       
    }}  className=" w-full lg:w-[48%] h-full flex justify-center  ">       
  </div>
  </div>
  )
}

export default Booking
